/**
 * LinkCopy components.
 *
 * copy link on click
 */

(() => {
  'use-strict';

  function init(elements) {
    elements.forEach((element) => {
      // Check that the target is not already initialized
      if ('initLinkCopy' in element.dataset) {
        return;
      }
      element.dataset.initLinkCopy = true;

      const link = element.getAttribute('href');
      const label = element.querySelector('[data-label]');
      const copyContent = async () => {
        try {
          await navigator.clipboard.writeText(link);
          label.classList.remove('-copy');
          label.classList.add('-copied');
        } catch (err) {
          // eslint-disable-next-line no-alert
          alert(Drupal.t('Failed to copy!'));
          // eslint-disable-next-line no-console
          console.error('Failed to copy: ', err);
        }
      };

      element.addEventListener('click', (event) => {
        event.preventDefault();

        copyContent();
      });
    });
  }

  Drupal.behaviors.linkCopy = {
    attach: () => {
      if (document.querySelectorAll('[data-link-copy]').length !== 0) {
        init(document.querySelectorAll('[data-link-copy]'));
      }
    },
  };
})();
